import { useEffect } from 'react';

const useResizeObserver = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Oberve size changes and post up to parent window
      const resizeObserver = new ResizeObserver(entries => {
        if (!window.parent) {
          return;
        }

        entries.forEach(entry => {
          window.parent.postMessage(
            {
              action: 'resize',
              value: {
                height: entry.contentRect.height,
                width: entry.contentRect.width,
              },
            },
            window.location.origin,
          );
        });
      });

      resizeObserver.observe(document.body);

      return () => resizeObserver.unobserve(document.body);
    }
  }, []);
};

export default useResizeObserver;
